import { z } from 'zod';

/**
 * Triage answer for one Linear issue. Passed to the model as a structured-output
 * contract, so the bot cannot return prose or a malformed block.
 */
export const PipelineTriageSchema = z.object({
  ready: z
    .boolean()
    .describe(
      'True when the issue states the goal, the observable result, and the area of the app, and leaves no product choice open.',
    ),
  missing: z.array(z.string()).describe('What the issue does not say. Empty when ready.'),
  questions: z
    .array(z.string())
    .max(5)
    .describe('At most five plain-language questions for Erik. Empty when ready.'),
  needsPlan: z
    .boolean()
    .describe(
      'True when the issue needs a written plan before a build agent can start. False when the issue already names the files to change and states the finished result precisely enough to build from directly, for example when it carries acceptance criteria. Answer false whenever a plan would only restate the issue.',
    ),
  tier: z
    .enum(['simple', 'standard', 'complex'])
    .describe(
      'complex: the work is hard enough to deserve the strongest model: it spans several packages, changes a shared contract or data model, has real architectural choices, or has to preserve behaviour that is easy to break. simple: the work is contained and its shape is already given, such as one copy change, one component, or a fix the issue spells out. standard: everything else. Judge the difficulty of the work, not its size or its importance.',
    ),
  touchesUi: z.boolean().describe('True when the work changes the user interface.'),
  touchesSchema: z.boolean().describe('True when the work changes the database schema.'),
});

export type PipelineTriageResult = z.infer<typeof PipelineTriageSchema>;
